import request from '@/utils/request'
import {
  serviceItem,
  printGACData,
  lastXcareItem,
  OperatorItemType,
  EditPPICThirdPartyLiabilityParams,
  ChangePingan2024ThirdPartyLiabilityInformationParams,
} from '@/types/three-liability-insurance'
export function getServiceList(params: { sn: string }): Promise<serviceItem> {
  return request.get(`/api-v2/app/nongfu/insurance/index/getPingAnInsurance`, { params })
}

export function getPingAnInsuranceList(params: { sn: string }): Promise<serviceItem[]> {
  return request
    .get(`/api-v3/insurance/renbao/getPingAnInsuranceList`, { params })
    .then((data) => (Array.isArray(data) ? data : data ? [data] : []) as serviceItem[])
}

export type PinganCorrectOperatorParams = {
  policy_no: string
  updated_by: string
  operator_list: OperatorItemType[]
}

export function modifyOperator(params: PinganCorrectOperatorParams): Promise<{
  status: number
  message: string
}> {
  return request.post(`/api-v2/app/nongfu/insurance/index/pingan_correct_operators`, params, {
    headers: {
      errorUnUseDefault: '1',
    },
  })
}

export function batchPinganCorrectInformation(
  list:
    | ChangePingan2024ThirdPartyLiabilityInformationParams
    | ChangePingan2024ThirdPartyLiabilityInformationParams[]
): Promise<{
  status: number
  message: string
}> {
  const data = Array.isArray(list) ? list : [list]
  const formData = new FormData()
  formData.append('data', JSON.stringify(data))
  return request.post(`/api-v3/insurance/renbao/batch_pingan_correct_information`, formData, {
    headers: {
      errorUnUseDefault: '1',
    },
  })
}

export function modifyInformation(
  params: ChangePingan2024ThirdPartyLiabilityInformationParams
): Promise<{
  status: number
  message: string
}> {
  return request.post(`/api-v2/app/nongfu/insurance/index/pingan_correct_information`, params, {
    headers: {
      errorUnUseDefault: '1',
    },
  })
}

type printGACParams = {
  policyNo: string
  endorseNo?: string
  electronicType: string
  isPrintClause: string
}

export function printGAC(params: printGACParams): Promise<printGACData> {
  return request.post(`/api-v2/app/nongfu/insurance/index/printGAC`, params, {
    headers: {
      errorUnUseDefault: '1',
    },
  })
}

export function getlastXcare(params: { serial_number: string }): Promise<lastXcareItem[]> {
  return request.get(`/api/agri/common/equipments/last-xcare`, { params })
}

export function editPPICThirdPartyLiability(
  params: EditPPICThirdPartyLiabilityParams
): Promise<void> {
  return request.post(`/api-v3/insurance/renbao/renBaoCorrect`, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}
